import { ActivitySummaryResponseBuilder } from 'gql/autogen/ActivitySummaryResponseBuilder';
import { DurationInfoResponseBuilder } from 'gql/autogen/DurationInfoResponseBuilder';
import { ActivityLocationResponseBuilder } from 'gql/autogen/ActivityLocationResponseBuilder';
import { CityValueResponseBuilder } from 'gql/autogen/CityValueResponseBuilder';
import { GeoInfoResponseBuilder } from 'gql/autogen/GeoInfoResponseBuilder';
import { CountryValueResponseBuilder } from 'gql/autogen/CountryValueResponseBuilder';

export const buildActivitySummaryResponseQuery = () => {
    return new ActivitySummaryResponseBuilder()
        .withTitle()
        .withCategories()
        .withDescription()
        .withDuration(new DurationInfoResponseBuilder().withMinutes().withMinutesUntil().withDurationType())
        .withLocation(
            new ActivityLocationResponseBuilder()
                .withCity(new CityValueResponseBuilder().withId().withName())
                .withAddressLine()
                .withGeo(new GeoInfoResponseBuilder().withLat().withLong())
                .withCountry(new CountryValueResponseBuilder().withId().withName())
                .withPostalCode(),
        );
};
